module.exports = __webpack_public_path__ + "img/club.74a03937.png";